// extracted by mini-css-extract-plugin
export default {"pageContainer":"account-deletion-policy_pageContainer__EUuQf","policyContent":"account-deletion-policy_policyContent__HxEOr"};